import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { getFitmentOptionQS } from "../../util/vehicle/get-fitment-option-q-s";
import { IValidateProductFitsResponse } from "../interfaces/shoping-cart.type";

export function checkItemFitmentApi(sku: string, vehicle: IVehicle) {
  const serVehicle = vehicle || {};
  const { fitmentOptions, ...selectedVehicle } = serVehicle;
  const fitmentOptionQS = getFitmentOptionQS(fitmentOptions, true);

  return axios.get<IValidateProductFitsResponse>(`/add-to-cart-pre-check?${fitmentOptionQS}`, {
    params: {
      sku,
      ...selectedVehicle,
    },
  });
}
